import { supabase } from '../../shared/supabase/supabaseClient';

export type VehicleServiceHistoryEntry = {
  entryType: 'part' | 'task';
  entryId: string;
  workOrderId: string;
  workOrderStatus: string;
  productId: string;
  productName: string;
  quantity: number;
  unitPrice: number;
  lineTotal: number;
  createdAt: string;
};

export type VehicleServiceSummary = {
  totalParts: number;
  totalServices: number;
  totalAll: number;
  partsCount: number;
  servicesCount: number;
  workOrdersCount: number;
};

export async function listVehicleServiceHistory(
  vehicleId: string,
): Promise<VehicleServiceHistoryEntry[]> {
  const { data, error } = await supabase.rpc('list_vehicle_service_history', {
    p_vehicle_id: vehicleId,
  });
  if (error) throw new Error(error.message);
  const rows = (data ?? []) as Array<{
    entry_type: string;
    entry_id: string;
    work_order_id: string;
    work_order_status: string;
    product_id: string;
    product_name: string;
    quantity: number;
    unit_price: number;
    line_total: number;
    created_at: string;
  }>;
  return rows.map((r) => ({
    entryType: r.entry_type as 'part' | 'task',
    entryId: r.entry_id,
    workOrderId: r.work_order_id,
    workOrderStatus: r.work_order_status,
    productId: r.product_id,
    productName: r.product_name,
    quantity: Number(r.quantity),
    unitPrice: Number(r.unit_price),
    lineTotal: Number(r.line_total),
    createdAt: r.created_at,
  }));
}

export async function getVehicleServiceSummary(
  vehicleId: string,
): Promise<VehicleServiceSummary | null> {
  const { data, error } = await supabase.rpc('get_vehicle_service_summary', {
    p_vehicle_id: vehicleId,
  });
  if (error) throw new Error(error.message);
  if (!data || !Array.isArray(data) || data.length === 0) return null;
  const r = data[0] as {
    total_parts: number;
    total_services: number;
    total_all: number;
    parts_count: number;
    services_count: number;
    work_orders_count: number;
  };
  return {
    totalParts: Number(r.total_parts),
    totalServices: Number(r.total_services),
    totalAll: Number(r.total_all),
    partsCount: Number(r.parts_count),
    servicesCount: Number(r.services_count),
    workOrdersCount: Number(r.work_orders_count),
  };
}
